<template>
  <basic-container>
    <avue-form
      :option="searchOption"
      v-model="searchForm"
      ref="searchFormRef"
      v-show="searchBoxFlag"
    >
      <template slot="nursinghomeId">
        <el-select
          v-model="searchForm.nursinghomeId"
          style="width:100%"
          placeholder="服务网点"
        >
          <el-option
            v-for="item in nursinghomeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="alertType">
        <el-select
          v-model="searchForm.alertType"
          style="width:100%"
          placeholder="报警类型"
          clearable
          @change="alertTypeChange"
        >
          <el-option
            v-for="item in alertTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="alertName">
        <el-select
          v-model="searchForm.alertName"
          style="width:100%"
          placeholder="报警名称"
          clearable
        >
          <el-option
            v-for="item in alertNameList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="_timeRange">
        <el-date-picker
          v-model="timeRange"
          style="width: 100%;"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          range-separator="至"
          clearable
        ></el-date-picker>
      </template>
      <template slot="menuForm">
        <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
          搜索
        </el-button>
        <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
      </template>
    </avue-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
      @cell-click="cellClick"
      :cell-style="cellStyle"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot="searchMenu"> </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-if="permissionList.handleBtn"
          size="small"
          @click="doOperation('handle')"
          >处 理
        </el-button>
        <el-button
          type="primary"
          v-if="permissionList.exportBtn"
          size="small"
          icon="el-icon-plus"
          @click="exportExcel()"
          >导 出
        </el-button>
      </template>
    </avue-crud>
    <!-- 处理弹框 -->
    <el-dialog
      title="处理"
      :width="'40%'"
      :visible.sync="formDialogShow"
      :before-close="beforeCloseFormDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <handleForm
        v-if="formDialogShow"
        :ids="handleIds"
        :nursinghomeId="this.searchForm.nursinghomeId"
        @success="recordSuccess"
        @cancle="recordCancle"
        @close="beforeCloseFormDialog"
      ></handleForm>
    </el-dialog>
    <hr-dialog
      :title="'查看'"
      :allowFull="false"
      width="60%"
      @close="closeAddOldManDialog"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <peopleForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          @stepsuccess="onLoad"
          :nursinghomeId="this.searchForm.nursinghomeId"
          :nursinghomeName="this.nursinghomeName"
        ></peopleForm>
      </template>
    </hr-dialog>
  </basic-container>
</template>
<script>
import { getNursinghomeList } from '../../api/public.js';
import { getAlarmMonitoringList } from '@/api/nursingHome/security.js';
import searchFromShow from '@/components/search-form-show/index';
import peopleForm from '@/views/nursingHome/oldPeople/peopleForm.vue';
import handleForm from './components/handleForm.vue';

import { getDicList } from  '@/api/nursingHome/artificalDevice';
import { getDictionary } from '@/api/common.js';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import { removeStore, getStore } from '@/util/store';
export default {
  components: { searchFromShow, peopleForm, handleForm },
  data() {
    return {
      searchForm: {
        nursinghomeId: '',
      },
      searchOption: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 100,
        menuSpan: 6,
        menuPosition: 'right',
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            span: 6,
            formslot: true,
            // type: 'select',
            // dataType: 'number',
            // props: {
            //   label: 'name',
            //   value: 'id',
            // },
            // dicUrl: '/api/nursing/getNursinghome',
            // hide: true,
            // search: true,
            // searchOrder: 6
          },
          {
            label: '老人姓名',
            prop: 'elderlyName',
            span: 6,
            placeholder: '老人姓名',
          },
          {
            label: '处理状态',
            prop: 'handleStatus',
            span: 6,
            placeholder: '处理状态',
            type: 'select',
            // search: true,
            // searchOrder: 4,
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=handle_status',
          },
          {
            label: '报警类型',
            prop: 'alertType',
            span: 6,
            formslot: true,
          },
          {
            label: '报警名称',
            prop: 'alertName',
            span: 6,
            formslot: true,
            // search: true,
            // searchOrder: 2,
          },
          {
            label: '报警时间区间',
            prop: '_timeRange',
            span: 12,
            // search: true,
            // searchOrder: 1,
            // hide: true,
            // searchSpan: 12,
            // searchslot: true,
            formslot: true,
          },
        ],
      },
      timeRange: [],
      nursinghomeList: [],
      option: {
        selection: true,
        tip: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        searchBtn: false,
        emptyBtn: false,
        searchShowBtn: false,
        searchLabelWidth: 100,
        searchMenuSpan: 6,
        column: [
          {
            label: '老人姓名',
            prop: 'elderlyName',
            // search: true,
            // searchOrder: 5
          },
          {
            label: '设备类型',
            prop: 'deviceTypeName',
          },
          {
            label: '设备IMEI号',
            prop: 'deviceIMEICode',
            minWidth: 100,
          },
          {
            label: '设备名称',
            prop: 'deviceName',
          },
          {
            label: '告警设备',
            prop: 'device433Name',
          },
          {
            label: '报警名称',
            prop: 'alertName',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_device_alert_type',
          },
          {
            label: '报警类型',
            prop: 'alertType',
            // search: true,
            // searchOrder: 3,
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_device_alert_type',
          },
          {
            label: '报警时间',
            prop: 'alertTime',
            minWidth: 120,
          },
          {
            label: '发生位置',
            prop: 'locationName',
            minWidth: 110,
          },
          {
            label: '状态',
            prop: 'handleStatus',
            type: 'select',
            // search: true,
            // searchOrder: 4,
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=handle_status',
          },
          {
            label: '处理人',
            prop: 'handleUser',
          },
          {
            label: '处理时间',
            prop: 'handleDate',
            minWidth: 120,
          },
          {
            label: '处理内容',
            prop: 'handleContent',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      exportForm: {},
      selectionIds: [], // 选中的数据集合
      nursingFormVisible: false,
      formDialogShow: false,
      needCloseConfirm: false,
      handleIds: '',
      alertTypeList: [],
      alertNameList: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        handleBtn: this.vaildData(this.permission.alarm_monitoring_handle, false),
        exportBtn: this.vaildData(this.permission.alarm_monitoring_export, false),
      };
    },
    nursinghomeName() {
      let name = '';
      const nId = this.searchForm.nursinghomeId;
      console.log('this.nursingHomeList-2', this.nursinghomeList);
      if (nId && this.nursinghomeList.length) {
        const item = this.nursinghomeList.find((item) => item.id === nId);
        name = item.name;
      }
      return name;
    }
  },
  mounted() {
    this.calcHeight();
    // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
    setTimeout(() => {
      window.onresize = () => {
        this.$nextTick(() => {
          this.$refs.crud.refreshTable();
        });
      };
    });
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
    // 从消息通知跳转过来时
    const { id, nursinghomeId } = this.$route.query;    
    if (id && nursinghomeId) {
      this.searchForm.nursinghomeId = nursinghomeId;
      this.searchForm.id = id;
      if (this.nursinghomeList.length && this.alertTypeList.length) {
        setTimeout(() => {
          this.onLoad();
        });
      } else {
        this.initData();
      }      
    }
  },
  methods: {
    recordSuccess() {
      this.formDialogShow = false;
      this.nursingFormVisible = false;
      this.handleIds = '';
      this.onLoad();
    },
    recordCancle() {
      removeStore({
        name: 'elderId'
      });
      this.handleIds = '';
      this.formDialogShow = false;
      this.nursingFormVisible = false;
    },
    closeAddOldManDialog() {
      removeStore({
        name: 'elderId'
      });
    },
    cellClick(row, column) {
      console.log('cellClick-', row);
      console.log('cellClick-column-', column);
      if (column.label === '老人姓名') {
        if (row.elderlyName) {
          this.formModel = 'view';
          this.formRow = {...row, id: row.elderlyId };
          this.nursingFormVisible = true;
        }
      }
    },
    cellStyle({ column }) {
      if (column.label === '老人姓名') {
        return {
          color: '#409eff',
          cursor: 'pointer',
        };
      }
    },
    doOperation(type, row) {
      switch (type) {
        case 'handle':
          this.handle();
          break;
        default:
          break;
      }
    },
    handle() {
      if (!this.selectionIds.length) {
        this.$message({
          message: '请选择要处理的数据',
          type: 'warning',
        });
        return;
      }
      // 所有的都已处理
      const flag = this.selectionIds.every(item => item.handleStatus == '2');
      if (flag) {
        this.$message({
          message: '您选择的数据都已处理过了，无需再处理',
          type: 'warning',
        });
        return;
      }
      const ids = this.selectionIds.map(item => item.id).join(',');
      this.handleIds = ids;
      this.formDialogShow = true;
      this.needCloseConfirm = true;
    },
    selectionChange(val) {
      this.selectionIds = val;
    },
    exportExcel() {
      this.$confirm('是否导数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        // 将条件参数拼接为路由传参格式
        let paramFormString = this.tool.objToform(this.exportForm);
        //
        this.tool.downloadFile(
          `/api/v4ward/nursinghome/device/alert/exportAlert?${
            this.website.tokenHeader
          }=${getToken()}&${paramFormString}`,
          'abc.xlsx',
          'xlsx/xls'
        );
      });
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseFormDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.formDialogShow = false;
          this.handleIds = '';
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.formDialogShow = false;
              this.handleIds = '';
            }
          })
          .catch(() => {});
      }
    },

    // deleteFun(id) {
    //   this.$confirm(' 是否删除该数据?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       serviceItemRemove(id).then((re) => {
    //         this.$message.success('删除成功');
    //         this.onLoad();
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消操作',
    //       });
    //     });
    // },
    dealTime() {
      console.log('this.searchForm.timeRange=========>', this.timeRange);
      if (this.timeRange && this.timeRange.length > 0) {
        this.searchForm.startTime = this.dayjs(this.timeRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchForm.endTime = this.dayjs(this.timeRange[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
    searchRecord() {
      this.page.currentPage = 1;
      this.dealTime();
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.page.currentPage = 1;
      this.timeRange = [];
      this.dealTime();
      this.onLoad();
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    alertTypeChange(){
      this.searchForm.alertName =''
      this.alertNameList =[]
      this.alertTypeList.forEach(item=>{
        if(item.dictKey==this.searchForm.alertType){
          this.alertNameList = item.children
        }
      })
    },
    initData() {
      // 获取告警类型
      getDicList({code:'nursinghome_device_alert_type'}).then(res=>{
        this.alertTypeList =res.data[0].children        
      })
      getNursinghomeList().then((res) => {
        const list = res.data;        
        if (list.length > 0) {
          // const clm = this.findObject(this.searchOption.column, 'nursinghomeId');          
          // clm.dicData = list.map(item => {
          //   return {
          //     label: item.name,
          //     value: item.id
          //   }
          // });
          this.nursinghomeList = [].concat(list);
          if (!this.$route.query.nursinghomeId) {
            this.$set(this.searchForm, 'nursinghomeId', list[0].id);
          }          
          this.onLoad();
        }
      });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId) {
        this.loading = true;
        this.exportForm = this.searchForm;
        getAlarmMonitoringList(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style>
#form > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
